import sdkProvider from "../../../../client/sdkProvider";
import { setLoyaltyIsEnabled } from ".";
import logger from "../../../../lib/logger";

const loadLoyaltyIsEnabled = () => async dispatch => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");
    const isLoyaltyEnabled = await loyaltySdk.isLoyaltyAvailable();
    dispatch(setLoyaltyIsEnabled(isLoyaltyEnabled));
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      error.message = `loadLoyaltyIsEnabled failed with error: ${error.message}`;
      logger.error(error);
    }
  }
};

export default loadLoyaltyIsEnabled;
